import AdminSection, { humanize } from "./AdminSection";

const PRODUCTS = [
  { value: "from_diagnosis_to_goodbye", label: "From Diagnosis to Goodbye" },
  { value: "hospice_workbook", label: "Hospice Workbook" },
  { value: "bereavement_workbook", label: "Bereavement Workbook" },
  { value: "multiple", label: "Multiple" },
  { value: "other", label: "Other" },
];
const ORG_TYPES = [
  { value: "hospice", label: "Hospice" }, { value: "healthcare", label: "Healthcare" },
  { value: "senior_living", label: "Senior Living" }, { value: "board_and_care", label: "Board & Care" },
  { value: "faith_community", label: "Faith Community" }, { value: "employer", label: "Employer" },
  { value: "community", label: "Community" }, { value: "educational", label: "Educational" }, { value: "other", label: "Other" },
];

const config = {
  title: "Bulk Orders",
  path: "bulk-orders",
  statuses: ["new", "reviewing", "quote_sent", "follow_up_needed", "approved", "completed", "declined", "closed"],
  extraFilters: [
    { key: "product", label: "products", options: PRODUCTS },
    { key: "organization_type", label: "org types", options: ORG_TYPES },
  ],
  columns: [
    { key: "created_at", label: "Submitted", render: (r) => new Date(r.created_at).toLocaleString() },
    { key: "organization", label: "Organization" },
    { key: "organization_type", label: "Org type" },
    { key: "product", label: "Product" },
    { key: "quantity", label: "Qty" },
    { key: "status", label: "Status" },
  ],
  detailFields: [
    { key: "name", label: "Contact", render: (r) => `${r.first_name} ${r.last_name}` },
    { key: "email", label: "Email" }, { key: "phone", label: "Phone" }, { key: "role", label: "Role" },
    { key: "organization", label: "Organization" },
    { key: "organization_type", label: "Organization type", render: (r) => humanize(r.organization_type) },
    { key: "product", label: "Product", render: (r) => humanize(r.product) },
    { key: "quantity", label: "Quantity" },
    { key: "message", label: "Message" },
    { key: "created_at", label: "Submitted", render: (r) => new Date(r.created_at).toLocaleString() },
  ],
};

export default function AdminBulkOrders() { return <AdminSection config={config} />; }
